import React from "react";
import "../Supporting.scss";

interface Props {
  title: any;
  name?: string;
  value: boolean;
  attrName: any;
  id?: string;
  value_update: Function;
  default_check: boolean;
}

const CheckBox: React.FC<Props> = ({
  title,
  name,
  id,
  value,
  attrName,
  value_update,
  default_check,
}) => {
  return (
    <div className="checkBox">
      <input
        id={id}
        type="checkbox"
        defaultChecked={default_check}
        checked={value}
        name={name}
        onChange={(e) => {
          value_update(attrName, e.target.checked);
        }}
      />
      <label htmlFor={id}>{title}</label>
    </div>
  );
};

export default CheckBox;
